/*
  Promo tile cycling in collection grids (sections/mm-collection-grid.liquid, Theme settings > Promo tiles).
  Fades to the next tile every few seconds; pauses while hovered, keyboard focused, off screen or in a hidden tab.
  Dots jump to a tile, the previous / next buttons step through them, and a sideways swipe on a touch screen does the
  same (vertical scrolling is left to the browser via touch-action: pan-y in assets/mm-promo-cycle.css).
  Any manual change restarts the timer. Reduced motion: no automatic change, the controls still work.
*/
(function () {
  var SWIPE_MIN = 40; // px of sideways travel before a touch counts as a swipe

  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mm-promo--slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.mm-promo-cycle__dot'));
    if (slides.length < 2) return;
    var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var ms = Math.max(4, parseInt(root.dataset.seconds, 10) || 6) * 1000;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovered = false, focused = false, visible = true, timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('tabindex'); s.removeAttribute('aria-hidden'); }
        else { s.setAttribute('tabindex', '-1'); s.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function tick() { if (!hovered && !focused && visible && !document.hidden) show(i + 1); }
    function run() { clearInterval(timer); if (!still) timer = setInterval(tick, ms); }
    function go(n) { show(n); run(); }

    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10) || 0); }); });
    root.querySelectorAll('[data-mm-promo-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + (parseInt(b.dataset.mmPromoStep, 10) || 1)); });
    });
    // Arrow keys while a control inside the tile has focus.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!e.target.closest('.mm-promo-cycle__dot, .mm-promo-cycle__nav')) return;
      e.preventDefault();
      go(i + (e.key === 'ArrowRight' ? 1 : -1));
    });

    // Hover pause for a real mouse only: a tap fires compatibility mouse events that never send a matching leave.
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovered = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hovered = false; });
    // Pause for keyboard focus only; a mouse click or tap on a control should not freeze the cycle.
    root.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      focused = kb;
    });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) focused = false; });
    if ('IntersectionObserver' in window) {
      // Several entries can queue up (scrolled out and back quickly); the last one is the current state.
      new IntersectionObserver(function (entries) { visible = entries[entries.length - 1].isIntersecting; }).observe(root);
    }

    // Touch swipe. Pointer events cover every current phone browser; mouse input is ignored.
    var sx = 0, sy = 0, pid = null, swiped = false, swipeClear = null;
    function reset() { pid = null; }
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      if (e.target.closest('.mm-promo-cycle__dot, .mm-promo-cycle__nav')) return;
      pid = e.pointerId; sx = e.clientX; sy = e.clientY;
    });
    root.addEventListener('pointerup', function (e) {
      if (e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      reset();
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      swiped = true;
      clearTimeout(swipeClear);
      swipeClear = setTimeout(function () { swiped = false; }, 500);
      go(i + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('pointercancel', reset);
    // A swipe must not open the tile's link; a plain tap still does.
    root.addEventListener('click', function (e) {
      if (!swiped) return;
      swiped = false;
      if (e.target.closest('.mm-promo--slide')) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    run();
  }
  function all() { document.querySelectorAll('[data-mm-promo-cycle]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
